import { formatPrice } from "../helpers";
import PanelController from "./panel-controller";

export default class extends PanelController {
    static targets = ["panel", "item", "variantId"];

    togglePanel(e, variant, product) {
        this.active = !this.active;
        e?.preventDefault();

        if (this.active) {
            this.buildItem(variant, product);
            this.panelTarget.classList.add("panel--active");
            document.body.classList.add("no-scroll");
        } else {
            this.panelTarget.classList.remove("panel--active");
            document.body.classList.remove("no-scroll");
            this.clearItem();
        }
    }

    buildItem(variant, product) {
        const { innerText, dataset, parentElement } = variant;

        const wrap = document.createElement("div");
        wrap.innerHTML = this.itemTarget.innerHTML;

        wrap.querySelector(".line-item__image").src = dataset.imageSrc;
        wrap.querySelector(".line-item__variant").innerText = innerText;
        wrap.querySelector(".line-item__title").innerText =
            parentElement.dataset.product;
        wrap.querySelector(".line-item__price").innerText = formatPrice(
            dataset.price
        );

        // this.productIdTarget.value = product.getAttribute("id");
        this.variantIdTarget.value = variant.value;
        this.itemTarget.innerHTML = wrap.innerHTML;
    }

    clearItem() {
        const src =
            this.itemTarget.querySelector(".line-item__image").dataset.src;
        const dataSrc = src;
        this.itemTarget.innerHTML = `
      <img class="line-item__image" src="${src}" alt="{{title}}" data-src="${dataSrc}" height="110" width="110" loading="lazy" />
      <div>
        <h3 class="line-item__title">{{title}}</h3>
        <p class="line-item__variant">{{variant}}</p>
        <p class="line-item__price">{{price}}</p>
      </div>
    `;
    }
}
